export const REDIRECT_URL = '/redirectUrl'

const redirectUrlRoutes = [REDIRECT_URL]

export default redirectUrlRoutes
